import { Component } from '@angular/core';
import { MetricasService } from './services/monitoring/metricas.service';

@Component({
	selector : 'trosten-app',
	template : `<router-outlet></router-outlet>`
})

export class AppComponent {
	// TR-22: arranca la medición de uso/tiempos (sólo activa en producción)
	constructor(metricas: MetricasService) {
		metricas.iniciar();
	}
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/app.component.ts